export interface iIcon {
    width?: string;
    height?: string;
    fill?: string;
    classes?: string;
    color?: string;
    onClick?: () => void;
}
export const UsersIcon = ({ className = '', width = 24, height = 24 }) => {
    const clipId = 'users_clip_1';
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath={`url(#${clipId})`}>
                <path d="M7.5 13C6.60998 13 5.73995 12.7361 4.99993 12.2416C4.25991 11.7471 3.68314 11.0443 3.34254 10.2221C3.00195 9.39981 2.91283 8.49501 3.08647 7.6221C3.2601 6.74918 3.68868 5.94736 4.31802 5.31802C4.94736 4.68868 5.74918 4.2601 6.62209 4.08647C7.49501 3.91283 8.39981 4.00195 9.22208 4.34254C10.0443 4.68314 10.7471 5.25991 11.2416 5.99994C11.7361 6.73996 12 7.60999 12 8.5C11.9987 9.69307 11.5241 10.8369 10.6805 11.6805C9.83689 12.5241 8.69307 12.9987 7.5 13ZM7.5 6C7.00555 6 6.5222 6.14662 6.11107 6.42133C5.69995 6.69603 5.37952 7.08648 5.1903 7.54329C5.00108 8.00011 4.95157 8.50278 5.04804 8.98773C5.1445 9.47268 5.3826 9.91814 5.73223 10.2678C6.08186 10.6174 6.52732 10.8555 7.01227 10.952C7.49723 11.0484 7.99989 10.9989 8.45671 10.8097C8.91352 10.6205 9.30397 10.3001 9.57867 9.88893C9.85338 9.4778 10 8.99446 10 8.5C10 7.83696 9.73661 7.20108 9.26777 6.73223C8.79893 6.26339 8.16304 6 7.5 6Z" />
                <path d="M15 23V22.5C15 20.5109 14.2098 18.6032 12.8033 17.1967C11.3968 15.7902 9.48912 15 7.5 15C5.51088 15 3.60322 15.7902 2.1967 17.1967C0.790176 18.6032 0 20.5109 0 22.5L0 23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24C1.26522 24 1.51957 23.8946 1.70711 23.7071C1.89464 23.5196 2 23.2652 2 23V22.5C2 21.0413 2.57946 19.6424 3.61091 18.6109C4.64236 17.5795 6.04131 17 7.5 17C8.95869 17 10.3576 17.5795 11.3891 18.6109C12.4205 19.6424 13 21.0413 13 22.5V23C13 23.2652 13.1054 23.5196 13.2929 23.7071C13.4804 23.8946 13.7348 24 14 24C14.2652 24 14.5196 23.8946 14.7071 23.7071C14.8946 23.5196 15 23.2652 15 23Z" />
                <path d="M24 18C24 16.6487 23.6088 15.3263 22.8737 14.1924C22.1386 13.0585 21.091 12.1616 19.8574 11.61C18.6238 11.0584 17.2569 10.8756 15.9218 11.0837C14.5866 11.2919 13.3402 11.8821 12.333 12.783C12.2338 12.8702 12.1528 12.9762 12.0948 13.0949C12.0367 13.2135 12.0028 13.3425 11.9949 13.4744C11.987 13.6063 12.0053 13.7384 12.0487 13.8631C12.0922 13.9879 12.1599 14.1028 12.2481 14.2012C12.3362 14.2996 12.4429 14.3796 12.5621 14.4366C12.6813 14.4935 12.8106 14.5262 12.9426 14.5329C13.0745 14.5396 13.2064 14.5201 13.3308 14.4754C13.4551 14.4308 13.5694 14.362 13.667 14.273C14.3865 13.6296 15.2767 13.2082 16.2304 13.0597C17.1841 12.9111 18.1604 13.0417 19.0414 13.4358C19.9225 13.8299 20.6706 14.4705 21.1956 15.2804C21.7206 16.0903 22 17.0348 22 18C22 18.2652 22.1054 18.5196 22.2929 18.7071C22.4804 18.8946 22.7348 19 23 19C23.2652 19 23.5196 18.8946 23.7071 18.7071C23.8946 18.5196 24 18.2652 24 18Z" />
                <path d="M17.5 9C16.61 9 15.74 8.73608 14.9999 8.24162C14.2599 7.74715 13.6831 7.04434 13.3425 6.22208C13.0019 5.39981 12.9128 4.49501 13.0865 3.6221C13.2601 2.74918 13.6887 1.94736 14.318 1.31802C14.9474 0.688685 15.7492 0.260102 16.6221 0.0864683C17.495 -0.0871652 18.3998 0.00194979 19.2221 0.342544C20.0443 0.683138 20.7471 1.25991 21.2416 1.99994C21.7361 2.73996 22 3.60999 22 4.5C21.9987 5.69307 21.5241 6.83689 20.6805 7.68052C19.8369 8.52415 18.6931 8.99868 17.5 9ZM17.5 2C17.0055 2 16.5222 2.14662 16.1111 2.42133C15.7 2.69603 15.3795 3.08648 15.1903 3.54329C15.0011 4.00011 14.9516 4.50278 15.048 4.98773C15.1445 5.47268 15.3826 5.91814 15.7322 6.26777C16.0819 6.6174 16.5273 6.8555 17.0123 6.95197C17.4972 7.04843 17.9999 6.99892 18.4567 6.8097C18.9135 6.62048 19.304 6.30005 19.5787 5.88893C19.8534 5.4778 20 4.99446 20 4.5C20 3.83696 19.7366 3.20108 19.2678 2.73223C18.7989 2.26339 18.163 2 17.5 2Z" />
            </g>

            <defs>
                <clipPath id="clip0_4492_5480">
                    <rect width="24" height="24" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const EditIcon = ({
    className = '',
    width = 24,
    height = 24,
    id,
    style,
    onClick,
}: {
    className?: string;
    width?: number;
    height?: number;
    id?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => {
    return (
        <svg
            id={id}
            style={style}
            onClick={onClick}
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m18.813,10c.309,0,.601-.143.79-.387s.255-.562.179-.861c-.311-1.217-.945-2.329-1.833-3.217l-3.485-3.485c-1.322-1.322-3.08-2.05-4.95-2.05h-4.515C2.243,0,0,2.243,0,5v14c0,2.757,2.243,5,5,5h3c.552,0,1-.448,1-1s-.448-1-1-1h-3c-1.654,0-3-1.346-3-3V5c0-1.654,1.346-3,3-3h4.515c.163,0,.325.008.485.023v4.977c0,1.654,1.346,3,3,3h5.813Zm-6.813-3V2.659c.379.218.732.488,1.05.806l3.485,3.485c.314.314.583.668.803,1.05h-4.338c-.551,0-1-.449-1-1Zm11.122,4.879c-1.134-1.134-3.11-1.134-4.243,0l-6.707,6.707c-.755.755-1.172,1.76-1.172,2.829v1.586c0,.552.448,1,1,1h1.586c1.069,0,2.073-.417,2.828-1.172l6.707-6.707c.567-.567.879-1.32.879-2.122s-.312-1.555-.878-2.121Zm-1.415,2.828l-6.708,6.707c-.377.378-.879.586-1.414.586h-.586v-.586c0-.534.208-1.036.586-1.414l6.708-6.707c.377-.378,1.036-.378,1.414,0,.189.188.293.439.293.707s-.104.518-.293.707Z" />
        </svg>
    );
};
export const CheckModalIcon = ({
    className = '',
    width = 24,
    height = 24,
    // viewBox = '0 0 24 24',
    // preserveAspectRatio = 'xMidYMid meet',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0.308506 14.9404L4.88751 19.5194C6.17514 20.8066 8.26239 20.8066 9.55003 19.5194L23.6915 5.3779C24.1132 4.94126 24.1011 4.24546 23.6644 3.82375C23.2385 3.41235 22.5632 3.41235 22.1373 3.82375L7.99587 17.9652C7.56664 18.3943 6.87089 18.3943 6.44172 17.9652L1.86271 13.3862C1.42607 12.9645 0.730264 12.9766 0.308558 13.4132C-0.102844 13.8392 -0.102844 14.5144 0.308506 14.9404Z" />
        </svg>
    );
};
export const CrossModalIcon = ({ className = '', width = 24, height = 24, viewBox = '0 0 24 24' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M13.4139 12L19.707 5.70758C20.0977 5.31694 20.0977 4.68359 19.707 4.29298C19.3164 3.90234 18.683 3.90234 18.2924 4.29298L12 10.586L5.70758 4.29298C5.31694 3.90234 4.68359 3.90234 4.29298 4.29298C3.90237 4.68362 3.90234 5.31697 4.29298 5.70758L10.586 12L4.29298 18.2924C3.90234 18.6831 3.90234 19.3164 4.29298 19.707C4.68362 20.0976 5.31697 20.0977 5.70758 19.707L12 13.4139L18.2924 19.707C18.683 20.0977 19.3164 20.0977 19.707 19.707C20.0976 19.3164 20.0976 18.683 19.707 18.2924L13.4139 12Z" />
        </svg>
    );
};
export const WithdrawIcon = ({ className = '', width = 24, height = 24, viewBox = '0 0 24 24' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m19.707,15.707l-1.293,1.293,1.293,1.293c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-1.293-1.293-1.293,1.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023,0-1.414l1.293-1.293-1.293-1.293c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l1.293,1.293,1.293-1.293c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414Zm4.293,1.293c0,3.859-3.141,7-7,7s-7-3.141-7-7,3.141-7,7-7,7,3.141,7,7Zm-2,0c0-2.757-2.243-5-5-5s-5,2.243-5,5,2.243,5,5,5,5-2.243,5-5Zm-12,6c0,.553-.447,1-1,1h-4c-2.757,0-5-2.243-5-5V5C0,2.243,2.243,0,5,0h4.515c1.869,0,3.627.728,4.95,2.05l2.501,2.502c.892.89,1.525,1.997,1.833,3.2.076.299.011.617-.179.861s-.481.387-.79.387h-5.116c-1.496,0-2.714-1.218-2.714-2.714V2.023c-.16-.015-.322-.023-.485-.023h-4.515c-1.654,0-3,1.346-3,3v14c0,1.654,1.346,3,3,3h4c.553,0,1,.447,1,1Zm2-16.714c0,.394.32.714.714.714h3.635c-.217-.374-.484-.722-.797-1.033l-2.501-2.502c-.318-.318-.671-.587-1.051-.805v3.626Z" />
        </svg>
    );
};
export const AcceptIcon = ({ className = '', width = 24, height = 24 }) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.6326 0.362077C20.0843 0.899635 20.1252 1.83613 19.7235 2.44261L8.41522 19.5162C8.01141 20.1259 7.31808 20.1646 6.87886 19.6022L0.335132 11.2224C-0.0729566 10.6998 -0.112021 9.829 0.238106 9.23368C0.624446 8.57677 1.3439 8.48635 1.80369 9.0489L6.88074 15.2609C7.32196 15.8008 8.00125 15.7525 8.39876 15.1531L18.1256 0.483102C18.5191 -0.110549 19.1904 -0.164361 19.6326 0.362077Z"
            />
        </svg>
    );
};
export const DeclineIcon = ({ className = '', width = 24, height = 24 }) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_4492_5517)">
                <path d="M16.0004 8C15.8129 7.81253 15.5586 7.70721 15.2934 7.70721C15.0283 7.70721 14.774 7.81253 14.5864 8L12.0004 10.586L9.41444 8C9.22584 7.81784 8.97323 7.71705 8.71104 7.71933C8.44884 7.72161 8.19803 7.82677 8.01262 8.01218C7.82721 8.19759 7.72204 8.4484 7.71976 8.7106C7.71749 8.9728 7.81828 9.2254 8.00044 9.414L10.5864 12L8.00044 14.586C7.81828 14.7746 7.71749 15.0272 7.71976 15.2894C7.72204 15.5516 7.82721 15.8024 8.01262 15.9878C8.19803 16.1732 8.44884 16.2784 8.71104 16.2807C8.97323 16.283 9.22584 16.1822 9.41444 16L12.0004 13.414L14.5864 16C14.775 16.1822 15.0276 16.283 15.2898 16.2807C15.552 16.2784 15.8028 16.1732 15.9883 15.9878C16.1737 15.8024 16.2788 15.5516 16.2811 15.2894C16.2834 15.0272 16.1826 14.7746 16.0004 14.586L13.4144 12L16.0004 9.414C16.1879 9.22647 16.2932 8.97216 16.2932 8.707C16.2932 8.44184 16.1879 8.18753 16.0004 8Z" />
                <path d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9966 8.81846 22.7312 5.76821 20.4815 3.51852C18.2318 1.26883 15.1815 0.00344108 12 0ZM12 22C10.0222 22 8.08879 21.4135 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92893C6.32746 3.53041 8.10929 2.578 10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.7612C17.6541 3.51808 19.2159 4.79981 20.3147 6.4443C21.4135 8.08879 22 10.0222 22 12C21.9971 14.6513 20.9426 17.1931 19.0679 19.0679C17.1931 20.9426 14.6513 21.9971 12 22Z" />
            </g>
        </svg>
    );
};
export const CopyIcon = ({ className = '', width = 24, height = 24 }) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4492_5474)">
                <path d="M12.8457 20C14.1713 19.9984 15.4421 19.4711 16.3795 18.5338C17.3168 17.5965 17.8441 16.3256 17.8457 15V6.24302C17.8473 5.71738 17.7445 5.19665 17.5433 4.71104C17.3421 4.22542 17.0465 3.78456 16.6737 3.41402L14.4317 1.17202C14.0612 0.799191 13.6203 0.50362 13.1347 0.302438C12.6491 0.101255 12.1283 -0.00153795 11.6027 1.73896e-05H6.8457C5.52011 0.00160525 4.24926 0.528899 3.31192 1.46624C2.37459 2.40358 1.84729 3.67442 1.8457 5.00002V15C1.84729 16.3256 2.37459 17.5965 3.31192 18.5338C4.24926 19.4711 5.52011 19.9984 6.8457 20H12.8457ZM3.8457 15V5.00002C3.8457 4.20437 4.16177 3.44131 4.72438 2.8787C5.28699 2.31609 6.05005 2.00002 6.8457 2.00002C6.8457 2.00002 11.7647 2.01402 11.8457 2.02402V4.00002C11.8457 4.53045 12.0564 5.03916 12.4315 5.41423C12.8066 5.7893 13.3153 6.00002 13.8457 6.00002H15.8217C15.8317 6.08102 15.8457 15 15.8457 15C15.8457 15.7957 15.5296 16.5587 14.967 17.1213C14.4044 17.6839 13.6414 18 12.8457 18H6.8457C6.05005 18 5.28699 17.6839 4.72438 17.1213C4.16177 16.5587 3.8457 15.7957 3.8457 15Z" />
                <path d="M21.8457 8.00002V19C21.8441 20.3256 21.3168 21.5965 20.3795 22.5338C19.4421 23.4711 18.1713 23.9984 16.8457 24H7.8457C7.58049 24 7.32613 23.8947 7.1386 23.7071C6.95106 23.5196 6.8457 23.2652 6.8457 23C6.8457 22.7348 6.95106 22.4804 7.1386 22.2929C7.32613 22.1054 7.58049 22 7.8457 22H16.8457C17.6414 22 18.4044 21.6839 18.967 21.1213C19.5296 20.5587 19.8457 19.7957 19.8457 19V8.00002C19.8457 7.7348 19.9511 7.48045 20.1386 7.29291C20.3261 7.10537 20.5805 7.00002 20.8457 7.00002C21.1109 7.00002 21.3653 7.10537 21.5528 7.29291C21.7403 7.48045 21.8457 7.7348 21.8457 8.00002Z" />
            </g>

            <defs>
                <clipPath id="clip0_4492_5474">
                    <rect width="24" height="24" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const OfferIcon = ({ className = '', width = 24, height = 24 }) => {
    return (
        <svg width={width} height={height} className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4167_1806)">
                <path d="M14 3.18225V3.81898C13.9926 3.99 13.9279 4.15122 13.8193 4.26926C13.7108 4.38731 13.5666 4.45315 13.4167 4.45315C13.2668 4.45315 13.1226 4.38731 13.014 4.26926C12.9055 4.15122 12.8408 3.99 12.8334 3.81898V3.18225C12.8222 2.66427 12.6317 2.17248 12.3036 1.81463C11.9756 1.45679 11.5367 1.26207 11.0832 1.27313H2.91681C2.4633 1.26207 2.02444 1.45679 1.69639 1.81463C1.36833 2.17248 1.17783 2.66427 1.16663 3.18225V9.54633C1.17783 10.0643 1.36833 10.5561 1.69639 10.9139C2.02444 11.2718 2.4633 11.4665 2.91681 11.4554H4.66651C4.74205 11.4511 4.81758 11.4643 4.88851 11.4943C4.95944 11.5243 5.02428 11.5705 5.0791 11.63C5.13392 11.6896 5.17757 11.7612 5.2074 11.8406C5.23722 11.92 5.2526 12.0055 5.2526 12.0919C5.2526 12.1783 5.23722 12.2638 5.2074 12.3432C5.17757 12.4226 5.13392 12.4942 5.0791 12.5538C5.02428 12.6133 4.95944 12.6595 4.88851 12.6895C4.81758 12.7195 4.74205 12.7327 4.66651 12.7284H2.91681C2.16093 12.7469 1.42947 12.4223 0.882729 11.8258C0.335984 11.2294 0.0185518 10.4097 0 9.54633L0 3.18225C0.0186755 2.31901 0.336162 1.49942 0.882894 0.903078C1.42963 0.306732 2.16102 -0.0177432 2.91681 0.000749215H11.0837C11.8394 -0.0175977 12.5706 0.306942 13.1173 0.903273C13.6639 1.4996 13.9813 2.3191 14 3.18225ZM8.74994 4.45517H11.0832C11.1587 4.45954 11.2343 4.44631 11.3052 4.41629C11.3761 4.38628 11.441 4.3401 11.4958 4.28057C11.5506 4.22104 11.5943 4.1494 11.6241 4.07C11.6539 3.99061 11.6693 3.90511 11.6693 3.81871C11.6693 3.73231 11.6539 3.64681 11.6241 3.56742C11.5943 3.48802 11.5506 3.41638 11.4958 3.35685C11.441 3.29732 11.3761 3.25114 11.3052 3.22113C11.2343 3.19111 11.1587 3.17788 11.0832 3.18225H8.74994C8.6744 3.17788 8.59887 3.19111 8.52794 3.22113C8.45701 3.25114 8.39217 3.29732 8.33735 3.35685C8.28253 3.41638 8.23888 3.48802 8.20906 3.56742C8.17923 3.64681 8.16385 3.73231 8.16385 3.81871C8.16385 3.90511 8.17923 3.99061 8.20906 4.07C8.23888 4.1494 8.28253 4.22104 8.33735 4.28057C8.39217 4.3401 8.45701 4.38628 8.52794 4.41629C8.59887 4.44631 8.6744 4.45954 8.74994 4.45517ZM13.4872 6.28727C13.649 6.46018 13.7781 6.66922 13.8663 6.90143C13.9545 7.13365 14 7.38408 14 7.63721C14 7.89034 13.9545 8.14078 13.8663 8.37299C13.7781 8.6052 13.649 8.81424 13.4872 8.98715L9.5747 13.255C9.12988 13.7377 8.53873 14.005 7.92518 14.0008H7.00024C6.92533 14.0028 6.8508 13.988 6.7809 13.9572C6.71101 13.9263 6.64714 13.88 6.59293 13.8209C6.53873 13.7618 6.49526 13.6911 6.46502 13.6128C6.43477 13.5345 6.41835 13.4501 6.41669 13.3646V12.3552C6.41706 12.0178 6.47792 11.6841 6.59552 11.3746C6.71311 11.0651 6.88494 10.7864 7.10043 10.5557L11.0129 6.28781C11.3483 5.92894 11.7907 5.72924 12.2503 5.72924C12.7099 5.72924 13.1523 5.92894 13.4877 6.28781L13.4872 6.28727ZM12.8334 7.63667C12.8332 7.55237 12.818 7.46899 12.7886 7.39167C12.7592 7.31434 12.7163 7.24471 12.6624 7.18705C12.5507 7.0674 12.4032 7.00081 12.2501 7.00081C12.0969 7.00081 11.9494 7.0674 11.8377 7.18705L7.92518 11.4549C7.81823 11.571 7.73284 11.7105 7.67411 11.8651C7.61537 12.0197 7.58449 12.1862 7.58331 12.3547V12.7278H7.92518C8.23199 12.7299 8.52757 12.5961 8.74994 12.3547L12.6624 8.08683C12.7163 8.02911 12.7593 7.95939 12.7887 7.88197C12.8181 7.80454 12.8333 7.72106 12.8334 7.63667ZM4.08343 9.54633H5.25006C5.70357 9.55739 6.14243 9.36267 6.47048 9.00483C6.79853 8.64698 6.98903 8.15519 7.00024 7.63721C6.99284 7.4662 6.92815 7.30498 6.81957 7.18693C6.71099 7.06888 6.56683 7.00304 6.41692 7.00304C6.26702 7.00304 6.12286 7.06888 6.01428 7.18693C5.9057 7.30498 5.84101 7.4662 5.83361 7.63721C5.83195 7.72278 5.81552 7.80713 5.78528 7.88544C5.75504 7.96375 5.71157 8.03448 5.65737 8.09357C5.60316 8.15267 5.53929 8.19897 5.46939 8.22983C5.3995 8.26068 5.32497 8.27549 5.25006 8.2734H4.08343C4.00852 8.27549 3.93399 8.26068 3.8641 8.22983C3.79421 8.19897 3.73033 8.15267 3.67613 8.09357C3.62192 8.03448 3.57845 7.96375 3.54821 7.88544C3.51797 7.80713 3.50155 7.72278 3.49988 7.63721V7.00048H4.66651C4.74205 7.00484 4.81758 6.99162 4.88851 6.9616C4.95944 6.93159 5.02428 6.88541 5.0791 6.82588C5.13392 6.76635 5.17757 6.69471 5.2074 6.61531C5.23722 6.53591 5.2526 6.45042 5.2526 6.36402C5.2526 6.27762 5.23722 6.19212 5.2074 6.11272C5.17757 6.03332 5.13392 5.96168 5.0791 5.90215C5.02428 5.84262 4.95944 5.79645 4.88851 5.76643C4.81758 5.73642 4.74205 5.72319 4.66651 5.72755H3.49988V5.09136C3.50155 5.00579 3.51797 4.92144 3.54821 4.84313C3.57845 4.76482 3.62192 4.6941 3.67613 4.635C3.73033 4.57591 3.79421 4.52961 3.8641 4.49875C3.93399 4.46789 4.00852 4.45308 4.08343 4.45517H5.25006C5.32497 4.45308 5.3995 4.46789 5.46939 4.49875C5.53929 4.52961 5.60316 4.57591 5.65737 4.635C5.71157 4.6941 5.75504 4.76482 5.78528 4.84313C5.81552 4.92144 5.83195 5.00579 5.83361 5.09136C5.84101 5.26238 5.9057 5.4236 6.01428 5.54165C6.12286 5.65969 6.26702 5.72553 6.41692 5.72553C6.56683 5.72553 6.71099 5.65969 6.81957 5.54165C6.92815 5.4236 6.99284 5.26238 7.00024 5.09136C6.98903 4.57338 6.79853 4.08159 6.47048 3.72375C6.14243 3.3659 5.70357 3.17118 5.25006 3.18225H4.08343C3.62992 3.17118 3.19107 3.3659 2.86301 3.72375C2.53496 4.08159 2.34446 4.57338 2.33325 5.09136V5.72755C2.25771 5.72319 2.18218 5.73642 2.11125 5.76643C2.04033 5.79645 1.97548 5.84262 1.92066 5.90215C1.86584 5.96168 1.8222 6.03332 1.79237 6.11272C1.76254 6.19212 1.74716 6.27762 1.74716 6.36402C1.74716 6.45042 1.76254 6.53591 1.79237 6.61531C1.8222 6.69471 1.86584 6.76635 1.92066 6.82588C1.97548 6.88541 2.04033 6.93159 2.11125 6.9616C2.18218 6.99162 2.25771 7.00484 2.33325 7.00048V7.63667C2.34434 8.15475 2.53478 8.64667 2.86285 9.00464C3.19092 9.3626 3.62984 9.55739 4.08343 9.54633ZM8.16687 6.36483C8.16146 6.49794 8.19108 6.62984 8.2519 6.74355C8.31272 6.85726 8.40196 6.94756 8.50811 7.00281C8.61427 7.05805 8.73248 7.07572 8.8475 7.05354C8.96253 7.03135 9.06911 6.97033 9.1535 6.87833C9.23788 6.78632 9.29622 6.66757 9.32098 6.53735C9.34574 6.40714 9.3358 6.27144 9.29243 6.14774C9.24906 6.02403 9.17425 5.918 9.07765 5.84331C8.98105 5.76861 8.86707 5.72867 8.75042 5.72864C8.67555 5.72655 8.60105 5.74134 8.53119 5.77216C8.46133 5.80299 8.39747 5.84924 8.34328 5.90828C8.28908 5.96731 8.2456 6.03798 8.21533 6.11622C8.18506 6.19447 8.16859 6.27876 8.16687 6.36429V6.36483Z" />
            </g>
            <defs>
                <clipPath id="clip0_4167_1806">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const OpenIcon = ({ className = '', width = 24, height = 24 }) => {
    return (
        <svg width={width} height={height} className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.13027 13.4167C9.13027 13.7387 8.85819 14 8.52158 14H3.04342C1.36528 14 0 12.6916 0 11.0833V2.91667C0 1.30842 1.36528 0 3.04342 0H5.79163C6.92927 0 7.99933 0.424667 8.80462 1.19583L10.9253 3.22933C11.0902 3.38742 11.2436 3.56067 11.3806 3.74442C11.576 4.00633 11.5127 4.37092 11.2394 4.55817C10.9661 4.74483 10.585 4.68475 10.3902 4.42225C10.2922 4.291 10.1827 4.16675 10.0652 4.05475L7.94394 2.02125C7.75038 1.83575 7.53552 1.67883 7.30422 1.55167V4.08333C7.30422 4.40475 7.57691 4.66667 7.9129 4.66667H9.73895C10.0756 4.66667 10.3476 4.928 10.3476 5.25C10.3476 5.572 10.0756 5.83333 9.73895 5.83333H7.9129C6.90614 5.83333 6.08685 5.04817 6.08685 4.08333V1.18008C5.98946 1.17133 5.89085 1.16667 5.79163 1.16667H3.04342C2.03666 1.16667 1.21737 1.95183 1.21737 2.91667V11.0833C1.21737 12.0482 2.03666 12.8333 3.04342 12.8333H8.52158C8.85819 12.8333 9.13027 13.0947 9.13027 13.4167ZM12.5906 9.48908L10.7396 9.19333C10.5126 9.15717 10.3476 8.9705 10.3476 8.75C10.3476 8.42858 10.6203 8.16667 10.9563 8.16667H12.3368C12.5535 8.16667 12.7556 8.27867 12.8645 8.45833C13.0319 8.73717 13.4032 8.83225 13.696 8.67125C13.987 8.50967 14.0868 8.15325 13.9176 7.87442C13.5925 7.33483 12.9863 6.99942 12.3362 6.99942H12.1731V6.41608C12.1731 6.09408 11.901 5.83275 11.5644 5.83275C11.2278 5.83275 10.9557 6.09408 10.9557 6.41608V6.99942C9.94895 6.99942 9.12966 7.78458 9.12966 8.74942C9.12966 9.54275 9.72252 10.2136 10.5388 10.3437L12.3898 10.6394C12.6168 10.6756 12.7818 10.8623 12.7818 11.0828C12.7818 11.4042 12.5091 11.6661 12.1731 11.6661H10.7926C10.5759 11.6661 10.3738 11.5541 10.2649 11.3744C10.0975 11.095 9.72556 10.9999 9.43339 11.1615C9.14244 11.3231 9.04262 11.6795 9.21183 11.9583C9.53687 12.4979 10.1431 12.8328 10.7932 12.8328H10.9563V13.4161C10.9563 13.7381 11.2284 13.9994 11.565 13.9994C11.9016 13.9994 12.1737 13.7381 12.1737 13.4161V12.8328C13.1805 12.8328 13.9997 12.0476 13.9997 11.0828C13.9997 10.2894 13.4069 9.61917 12.5906 9.48908ZM3.95645 8.75H7.30422C7.64082 8.75 7.9129 8.48867 7.9129 8.16667C7.9129 7.84467 7.64082 7.58333 7.30422 7.58333H3.95645C3.11768 7.58333 2.43474 8.23783 2.43474 9.04167V10.2083C2.43474 11.0122 3.11768 11.6667 3.95645 11.6667H7.30422C7.64082 11.6667 7.9129 11.4053 7.9129 11.0833C7.9129 10.7613 7.64082 10.5 7.30422 10.5H3.95645C3.78845 10.5 3.65211 10.3693 3.65211 10.2083V9.04167C3.65211 8.88067 3.78845 8.75 3.95645 8.75ZM3.04342 6.41667H4.26079C4.59679 6.41667 4.86948 6.15533 4.86948 5.83333C4.86948 5.51133 4.59679 5.25 4.26079 5.25H3.04342C2.70743 5.25 2.43474 5.51133 2.43474 5.83333C2.43474 6.15533 2.70743 6.41667 3.04342 6.41667ZM3.04342 4.08333H4.26079C4.59679 4.08333 4.86948 3.822 4.86948 3.5C4.86948 3.178 4.59679 2.91667 4.26079 2.91667H3.04342C2.70743 2.91667 2.43474 3.178 2.43474 3.5C2.43474 3.822 2.70743 4.08333 3.04342 4.08333Z" />
        </svg>
    );
};
export const DeleteIcon = ({ className = '', width = 24, height = 24 }) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M21 4H17.9C17.6679 2.87141 17.0538 1.85735 16.1613 1.12872C15.2687 0.40009 14.1522 0.00145452 13 0L11 0C9.8478 0.00145452 8.73132 0.40009 7.83875 1.12872C6.94618 1.85735 6.3321 2.87141 6.1 4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5C2 5.26522 2.10536 5.51957 2.29289 5.70711C2.48043 5.89464 2.73478 6 3 6H4V19C4.00159 20.3256 4.52888 21.5964 5.46622 22.5338C6.40356 23.4711 7.67441 23.9984 9 24H15C16.3256 23.9984 17.5964 23.4711 18.5338 22.5338C19.4711 21.5964 19.9984 20.3256 20 19V6H21C21.2652 6 21.5196 5.89464 21.7071 5.70711C21.8946 5.51957 22 5.26522 22 5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4ZM11 2H13C13.6203 2.00076 14.2251 2.19338 14.7316 2.55144C15.2381 2.90951 15.6214 3.41549 15.829 4H8.171C8.37858 3.41549 8.7619 2.90951 9.26839 2.55144C9.77487 2.19338 10.3797 2.00076 11 2ZM18 19C18 19.7956 17.6839 20.5587 17.1213 21.1213C16.5587 21.6839 15.7957 22 15 22H9C8.20435 22 7.44129 21.6839 6.87868 21.1213C6.31607 20.5587 6 19.7956 6 19V6H18V19Z" />
            <path d="M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18Z" />
            <path d="M14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z" />
        </svg>
    );
};
export const IconInvoice = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={color}
            width={width}
            height={height}
            className={classes}
            viewBox="0 0 18.01 18.792"
        >
            <path
                id="file-invoice-dollar"
                d="M12.745,18.009a.783.783,0,0,1-.783.783H4.915A3.92,3.92,0,0,1,1,14.877V3.915A3.92,3.92,0,0,1,4.915,0H8.45a5.448,5.448,0,0,1,3.876,1.605l2.728,2.73a5.51,5.51,0,0,1,.586.691.783.783,0,1,1-1.274.91,3.9,3.9,0,0,0-.418-.493l-2.729-2.73a3.924,3.924,0,0,0-.823-.63v3.4a.784.784,0,0,0,.783.783h2.349a.783.783,0,0,1,0,1.566H11.179A2.352,2.352,0,0,1,8.83,5.481v-3.9c-.125-.012-.252-.018-.38-.018H4.915A2.352,2.352,0,0,0,2.566,3.915V14.877a2.352,2.352,0,0,0,2.349,2.349h7.047A.783.783,0,0,1,12.745,18.009ZM17.2,12.737l-2.381-.4a.6.6,0,0,1-.5-.6.784.784,0,0,1,.783-.783H16.87a.788.788,0,0,1,.679.392A.783.783,0,1,0,18.9,10.57,2.356,2.356,0,0,0,16.869,9.4h-.21V8.612a.783.783,0,1,0-1.566,0V9.4a2.352,2.352,0,0,0-2.349,2.349,2.163,2.163,0,0,0,1.813,2.14l2.381.4a.6.6,0,0,1,.5.6.784.784,0,0,1-.783.783H14.884a.788.788,0,0,1-.679-.392.783.783,0,1,0-1.355.784,2.355,2.355,0,0,0,2.034,1.174h.21v.783a.783.783,0,0,0,1.566,0v-.783a2.352,2.352,0,0,0,2.349-2.349,2.163,2.163,0,0,0-1.813-2.14ZM6.09,11.745H10.4a.783.783,0,0,0,0-1.566H6.09a1.96,1.96,0,0,0-1.958,1.958V13.7A1.96,1.96,0,0,0,6.09,15.66H10.4a.783.783,0,0,0,0-1.566H6.09A.392.392,0,0,1,5.7,13.7V12.137a.392.392,0,0,1,.392-.392ZM4.915,8.613H6.481a.783.783,0,0,0,0-1.566H4.915a.783.783,0,0,0,0,1.566Zm0-3.132H6.481a.783.783,0,1,0,0-1.566H4.915a.783.783,0,1,0,0,1.566Z"
                transform="translate(-1)"
                fill={color}
            />
        </svg>
    );
};
export const IconCampaignBriefing = ({ width = '18', height = '18', classes = '', color = 'currentColor' }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path d="M10,23c0,.552-.448,1-1,1H5c-2.757,0-5-2.243-5-5V5C0,2.243,2.243,0,5,0H13c2.757,0,5,2.243,5,5v2c0,.552-.448,1-1,1s-1-.448-1-1v-2c0-1.654-1.346-3-3-3H5c-1.654,0-3,1.346-3,3v14c0,1.654,1.346,3,3,3h4c.552,0,1,.448,1,1ZM14,6c0-.552-.448-1-1-1H5c-.552,0-1,.448-1,1s.448,1,1,1H13c.552,0,1-.448,1-1ZM5,15c-.552,0-1,.448-1,1s.448,1,1,1h2c.552,0,1-.448,1-1s-.448-1-1-1h-2Zm19,2c0,3.86-3.14,7-7,7s-7-3.14-7-7,3.14-7,7-7,7,3.14,7,7Zm-2,0c0-2.757-2.243-5-5-5s-5,2.243-5,5,2.243,5,5,5,5-2.243,5-5Zm-5-4c-.828,0-1.5,.672-1.5,1.5s.672,1.5,1.5,1.5,1.5-.672,1.5-1.5-.672-1.5-1.5-1.5Zm0,4c-.552,0-1,.448-1,1v2c0,.552,.448,1,1,1s1-.448,1-1v-2c0-.552-.448-1-1-1Zm-7-6c0-.552-.448-1-1-1H5c-.552,0-1,.448-1,1s.448,1,1,1h4c.552,0,1-.448,1-1Z" />
        </svg>
    );
};
export const IconToDo = ({ width = '20', height = '20', classes, color, fill = '#9ea5ab' }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={color}
            width={width}
            height={height}
            className={classes}
            viewBox="0 0 19.888 19.908"
        >
            <path
                id="booking"
                d="M3.2,15.715a.83.83,0,0,1-1.133.3A4.158,4.158,0,0,1,0,12.429V5.8A4.149,4.149,0,0,1,4.143,1.657V.829A.829.829,0,1,1,5.8.829v.829h5.8V.829a.829.829,0,0,1,1.657,0v.829A4.148,4.148,0,0,1,17.4,5.8v6.629a.829.829,0,0,1-1.657,0V7.458h-.829a.829.829,0,1,1,0-1.657h.829a2.489,2.489,0,0,0-2.486-2.486H4.143A2.489,2.489,0,0,0,1.657,5.8H8.286a.829.829,0,0,1,0,1.657H1.657v4.972A2.5,2.5,0,0,0,2.9,14.583a.828.828,0,0,1,.3,1.132Zm14-.319-3.107-1.161v-4.18A2.554,2.554,0,0,0,12.02,7.514a2.487,2.487,0,0,0-2.9,2.452v6.267l-.841-.67c-.006,0-.013,0-.019-.01A2.482,2.482,0,0,0,4.928,19.23l.462.446a.829.829,0,0,0,1.15-1.193l-.471-.454A.829.829,0,0,1,7.2,16.815L9.435,18.6a.828.828,0,0,0,1.345-.648V9.963a.83.83,0,0,1,.974-.817.9.9,0,0,1,.684.906v4.755a.829.829,0,0,0,.539.776l3.645,1.362a2.488,2.488,0,0,1,1.61,2.164.829.829,0,0,0,.826.775c.018,0,.036,0,.055,0A.83.83,0,0,0,19.885,19,4.147,4.147,0,0,0,17.2,15.4Z"
                transform="translate(0.001)"
                fill={fill}
            />
        </svg>
    );
};

export const IconBook = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path d="M24,7v1c0,.552-.447,1-1,1s-1-.448-1-1v-1c0-1.654-1.346-3-3-3H5c-1.654,0-3,1.346-3,3v10c0,1.654,1.346,3,3,3h3c.553,0,1,.448,1,1s-.447,1-1,1h-3c-2.757,0-5-2.243-5-5V7C0,4.243,2.243,2,5,2h14c2.757,0,5,2.243,5,5Zm-9,2h4c.553,0,1-.448,1-1s-.447-1-1-1h-4c-.553,0-1,.448-1,1s.447,1,1,1Zm8.121,2.879c.566,.566,.879,1.32,.879,2.121s-.313,1.555-.879,2.122l-6.707,6.707c-.755,.755-1.76,1.172-2.828,1.172h-1.586c-.553,0-1-.448-1-1v-1.586c0-1.068,.416-2.073,1.172-2.828l6.707-6.707c1.17-1.17,3.072-1.17,4.242,0Zm-1.121,2.121c0-.267-.104-.518-.293-.707-.391-.391-1.023-.39-1.414,0l-6.707,6.707c-.372,.373-.586,.888-.586,1.414v.586h.586c.534,0,1.036-.208,1.414-.586l6.707-6.707c.189-.189,.293-.44,.293-.707Zm-15,3h2c1.654,0,3-1.346,3-3,0-.552-.447-1-1-1s-1,.448-1,1-.448,1-1,1h-2c-.552,0-1-.449-1-1v-1h2c.553,0,1-.448,1-1s-.447-1-1-1h-2v-1c0-.551,.448-1,1-1h2c.552,0,1,.449,1,1s.447,1,1,1,1-.448,1-1c0-1.654-1.346-3-3-3h-2c-1.654,0-3,1.346-3,3v1c-.553,0-1,.448-1,1s.447,1,1,1v1c0,1.654,1.346,3,3,3Zm7-5c0,.552,.448,1,1,1s1-.448,1-1-.448-1-1-1-1,.448-1,1Z" />
        </svg>
    );
};
export const IconLinkedCampaign = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path d="m12.5 14h-6.5c-.552 0-1-.448-1-1s.448-1 1-1h6.5c.552 0 1 .448 1 1s-.448 1-1 1zm-2.5 9c0 .552-.448 1-1 1h-4c-2.757 0-5-2.243-5-5v-14c0-2.757 2.243-5 5-5h4.515c1.87 0 3.627.728 4.95 2.05l3.485 3.485c.888.888 1.521 2 1.833 3.217.077.299.011.617-.179.861s-.481.387-.79.387h-5.813c-1.654 0-3-1.346-3-3v-4.977c-.16-.015-.322-.023-.485-.023h-4.516c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h4c.552 0 1 .448 1 1zm2-16c0 .551.449 1 1 1h4.338c-.219-.382-.489-.736-.803-1.05l-3.485-3.485c-.318-.318-.671-.587-1.05-.806zm-6 9c-.552 0-1 .448-1 1s.448 1 1 1h2.5c.552 0 1-.448 1-1s-.448-1-1-1zm16.828-3.808c-1.387-1.388-3.551-1.568-5.147-.432-.45.321-.554.945-.234 1.395.321.45.944.555 1.395.234.796-.568 1.877-.477 2.572.217.378.378.586.88.586 1.415s-.208 1.036-.586 1.414l-1.414 1.415c-.599.599-1.513.756-2.276.391-.498-.237-1.095-.028-1.333.471-.238.498-.027 1.095.471 1.333.549.262 1.136.39 1.72.39 1.04 0 2.066-.405 2.833-1.171l1.414-1.415c.756-.755 1.172-1.76 1.172-2.828s-.416-2.073-1.172-2.829zm-6.59 9.439c-.798.567-1.879.477-2.572-.217-.378-.378-.586-.88-.586-1.414s.208-1.036.586-1.414l1.414-1.415c.6-.598 1.514-.754 2.276-.391.497.237 1.095.028 1.333-.471.238-.498.027-1.095-.471-1.333-1.527-.73-3.356-.415-4.553.782l-1.414 1.415c-.756.755-1.172 1.76-1.172 2.828s.416 2.073 1.172 2.828c.777.778 1.799 1.172 2.828 1.172.807 0 1.618-.24 2.318-.74.45-.32.555-.945.234-1.395s-.945-.555-1.395-.234z" />
        </svg>
    );
};
export const IconDiscovery = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path d="m5 14c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1s-1-.448-1-1v-2c0-.552.448-1 1-1zm3-2v5c0 .552.448 1 1 1s1-.448 1-1v-5c0-.552-.448-1-1-1s-1 .448-1 1zm-3.5-9c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm4 0c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm15.5 2v6c0 .552-.447 1-1 1s-1-.448-1-1v-2h-20v8c0 1.654 1.346 3 3 3h5c.552 0 1 .448 1 1s-.448 1-1 1h-5c-2.757 0-5-2.243-5-5v-12c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5zm-2 2v-2c0-1.654-1.346-3-3-3h-14c-1.654 0-3 1.346-3 3v2zm1.707 15.293c.391.391.391 1.023 0 1.414s-1.023.391-1.414 0l-2.54-2.54c-.791.524-1.736.833-2.753.833-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5c0 1.017-.309 1.962-.833 2.753zm-6.707-2.293c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3z" />
        </svg>
    );
};

export const IconManagement = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path
                id="users-alt"
                d="M12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,12,10Zm6,13A6,6,0,0,0,6,23a1,1,0,0,0,2,0,4,4,0,0,1,8,0,1,1,0,0,0,2,0ZM18,8a4,4,0,1,1,4-4A4,4,0,0,1,18,8Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,18,2Zm6,13a6.006,6.006,0,0,0-6-6,1,1,0,0,0,0,2,4,4,0,0,1,4,4,1,1,0,0,0,2,0ZM6,8a4,4,0,1,1,4-4A4,4,0,0,1,6,8ZM6,2A2,2,0,1,0,8,4,2,2,0,0,0,6,2ZM2,15a4,4,0,0,1,4-4A1,1,0,0,0,6,9a6.006,6.006,0,0,0-6,6,1,1,0,0,0,2,0Z"
            />
        </svg>
    );
};
export const IconBundle = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={classes}
            fill={color}
            viewBox="0 0 17.219 20.662"
        >
            <path
                id="ballot-check"
                d="M10.348,10.088l-1.6,1.554a1.412,1.412,0,0,1-1,.412,1.44,1.44,0,0,1-1.018-.421l-.586-.563A.861.861,0,0,1,7.332,9.828l.407.392,1.41-1.367a.861.861,0,1,1,1.2,1.236Zm3.705,4.547H11.47a.861.861,0,1,0,0,1.722h2.583a.861.861,0,1,0,0-1.722Zm0-10.331H11.47a.861.861,0,1,0,0,1.722h2.583a.861.861,0,1,0,0-1.722Zm0,5.166H12.331a.861.861,0,1,0,0,1.722h1.722a.861.861,0,1,0,0-1.722ZM7.6,14.205A1.291,1.291,0,1,0,8.888,15.5,1.292,1.292,0,0,0,7.6,14.205Zm0-7.748A1.291,1.291,0,1,0,6.3,5.166,1.292,1.292,0,0,0,7.6,6.457ZM19.219,4.3V16.358a4.31,4.31,0,0,1-4.3,4.3H6.3a4.31,4.31,0,0,1-4.3-4.3V4.3A4.31,4.31,0,0,1,6.3,0h8.609A4.31,4.31,0,0,1,19.219,4.3ZM17.5,4.3a2.586,2.586,0,0,0-2.583-2.583H6.3A2.586,2.586,0,0,0,3.722,4.3V16.358A2.586,2.586,0,0,0,6.3,18.941h8.609A2.586,2.586,0,0,0,17.5,16.358Z"
                transform="translate(-2)"
            />
        </svg>
    );
};

export const IconManage = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path d="M17,10c-3.859,0-7,3.14-7,7s3.141,7,7,7,7-3.14,7-7-3.141-7-7-7Zm0,12c-2.757,0-5-2.243-5-5s2.243-5,5-5,5,2.243,5,5-2.243,5-5,5Zm1.707-4.707c.391,.391,.391,1.023,0,1.414-.195,.195-.451,.293-.707,.293s-.512-.098-.707-.293l-1-1c-.188-.188-.293-.442-.293-.707v-2c0-.552,.447-1,1-1s1,.448,1,1v1.586l.707,.707Zm-9.707,4.707H5c-1.654,0-3-1.346-3-3v-5h6c.553,0,1-.448,1-1s-.447-1-1-1H2v-3c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3,0,.552,.447,1,1,1s1-.448,1-1c0-2.757-2.243-5-5-5h-1.101c-.465-2.279-2.485-4-4.899-4h-2c-2.414,0-4.435,1.721-4.899,4h-1.101C2.243,4,0,6.243,0,9v10c0,2.757,2.243,5,5,5h4c.553,0,1-.448,1-1s-.447-1-1-1ZM11,2h2c1.304,0,2.415,.836,2.828,2h-7.656c.413-1.164,1.524-2,2.828-2Z" />
        </svg>
    );
};

export const IconMeasure = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path d="M22.5,3.976H19.414a1,1,0,0,0-.707,1.707l1.086,1.086h0l-3.586,3.585a1.024,1.024,0,0,1-1.415,0l-.17-.171a3.071,3.071,0,0,0-4.243,0l-5.1,5.1A1,1,0,1,0,6.7,16.7l5.1-5.1a1.023,1.023,0,0,1,1.415,0l.17.171a3.073,3.073,0,0,0,4.243,0l3.586-3.586h0l1.086,1.086A1,1,0,0,0,24,8.562V5.476A1.5,1.5,0,0,0,22.5,3.976Z" />
            <path d="M23,21.976H5a3,3,0,0,1-3-3V1A1,1,0,0,0,0,1V18.976a5.006,5.006,0,0,0,5,5H23a1,1,0,0,0,0-2Z" />
        </svg>
    );
};

export const IconMessage = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Outline"
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <path d="M24,16v8H16a8,8,0,0,1-6.92-4,10.968,10.968,0,0,0,2.242-.248A5.988,5.988,0,0,0,16,22h6V16a5.988,5.988,0,0,0-2.252-4.678A10.968,10.968,0,0,0,20,9.08,8,8,0,0,1,24,16ZM18,9A9,9,0,0,0,0,9v9H9A9.01,9.01,0,0,0,18,9ZM2,9a7,7,0,1,1,7,7H2Z" />
        </svg>
    );
};

export const IconDoubleArrow = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 10 10"
            fill={color}
            className={classes}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2117_1970)">
                <path d="M-5.50644e-05 4.99868C-0.000196205 4.91663 0.0158923 4.83537 0.0472844 4.75957C0.0786774 4.68377 0.124754 4.61493 0.182862 4.55701L3.37953 1.35868C3.8093 0.928929 4.39218 0.6875 4.99995 0.6875C5.60772 0.6875 6.1906 0.928929 6.62036 1.35868L9.81703 4.55534C9.93422 4.67259 10 4.83159 10 4.99737C9.99996 5.16314 9.93407 5.32211 9.81682 5.4393C9.69957 5.55649 9.54057 5.62231 9.3748 5.62227C9.20903 5.62223 9.05006 5.55634 8.93286 5.43909L5.73661 2.24243C5.63988 2.14567 5.52504 2.06892 5.39864 2.01655C5.27224 1.96419 5.13676 1.93723 4.99995 1.93723C4.86313 1.93723 4.72765 1.96419 4.60125 2.01655C4.47486 2.06892 4.36001 2.14567 4.26328 2.24243L1.06703 5.43909C0.97972 5.52646 0.868483 5.586 0.747362 5.61019C0.626243 5.63438 0.50067 5.62214 0.386499 5.57502C0.272328 5.5279 0.174679 5.44801 0.10588 5.34543C0.037081 5.24285 0.000218635 5.12219 -5.50644e-05 4.99868Z" />
                <path d="M0.000558133 8.97247C0.000520944 8.89038 0.0166552 8.80909 0.0480406 8.73324C0.0794261 8.65738 0.125447 8.58846 0.183475 8.53039L3.96931 4.74664C4.24307 4.47363 4.61393 4.32031 5.00056 4.32031C5.38719 4.32031 5.75804 4.47363 6.03181 4.74664L9.81764 8.53039C9.9294 8.64871 9.99059 8.80595 9.98821 8.96868C9.98584 9.13142 9.92007 9.28681 9.80491 9.40181C9.68975 9.51681 9.53426 9.58235 9.37153 9.5845C9.20879 9.58665 9.05163 9.52523 8.93347 9.41331L5.14806 5.62747C5.12871 5.60807 5.10572 5.59268 5.08041 5.58218C5.05509 5.57167 5.02796 5.56627 5.00056 5.56627C4.97315 5.56627 4.94602 5.57167 4.92071 5.58218C4.8954 5.59268 4.87241 5.60807 4.85306 5.62747L1.06764 9.41331C0.980308 9.5007 0.869033 9.56024 0.747874 9.58442C0.626715 9.6086 0.501107 9.59633 0.386919 9.54916C0.272731 9.50198 0.175086 9.42202 0.10632 9.31938C0.0375531 9.21674 0.000748863 9.09602 0.000558133 8.97247Z" />
            </g>
            <defs>
                <clipPath id="clip0_2117_1970">
                    <rect width="10" height="10" fill="white" transform="translate(10) rotate(90)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const IconArrow = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 10 10"
            fill={color}
            className={classes}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2117_1975)">
                <path
                    d="M9.37081 7.46544C9.28873 7.46555 9.20745 7.44941 9.13164 7.41794C9.05584 7.38648 8.98702 7.34031 8.92914 7.28211L5.73206 4.08544C5.63533 3.98869 5.52049 3.91193 5.39409 3.85957C5.26769 3.8072 5.13221 3.78025 4.9954 3.78025C4.85858 3.78025 4.7231 3.8072 4.5967 3.85957C4.4703 3.91193 4.35546 3.98869 4.25873 4.08544L1.06664 7.27794C1.00899 7.33764 0.940025 7.38525 0.863772 7.41801C0.78752 7.45076 0.705507 7.468 0.62252 7.46873C0.539534 7.46945 0.457233 7.45363 0.380424 7.42221C0.303613 7.39078 0.233831 7.34437 0.175148 7.28569C0.116466 7.22701 0.0700569 7.15723 0.0386315 7.08042C0.007206 7.00361 -0.00860782 6.92131 -0.00788683 6.83832C-0.00716585 6.75533 0.0100756 6.67332 0.0428315 6.59707C0.0755874 6.52081 0.123201 6.45185 0.182895 6.39419L3.37498 3.20169C3.80502 2.77246 4.38779 2.53138 4.9954 2.53138C5.603 2.53138 6.18577 2.77246 6.61581 3.2017L9.81289 6.39836C9.90036 6.48577 9.95993 6.59716 9.98407 6.71844C10.0082 6.83971 9.99583 6.96542 9.9485 7.07966C9.90118 7.1939 9.82102 7.29153 9.71819 7.3602C9.61536 7.42888 9.49447 7.4655 9.37081 7.46544Z"
                    // fill="#9EA5AB"
                />
            </g>
            <defs>
                <clipPath id="clip0_2117_1975">
                    <rect width="10" height="10" fill="white" transform="translate(10 10) rotate(-180)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const BestPicks = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={color}
            width={width}
            className={classes}
            height={height}
            viewBox="0 0 24 24"
        >
            <g id="Icon_ionic-md-ribbon" data-name="Icon ionic-md-ribbon" transform="translate(-4.5 -2.25)">
                <path
                    id="Path_1430"
                    data-name="Path 1430"
                    d="M14.773,2.25a5.773,5.773,0,1,0,5.773,5.773A5.772,5.772,0,0,0,14.773,2.25Zm0,9.381a3.608,3.608,0,1,1,3.608-3.608A3.607,3.607,0,0,1,14.773,11.631Z"
                    transform="translate(-1.614)"
                />
                <g id="Group_2842" data-name="Group 2842" transform="translate(4.5 12.93)">
                    <path
                        id="Path_1431"
                        data-name="Path 1431"
                        d="M10.35,20.641a7.138,7.138,0,0,1-2.291-1.547c-.063-.063-.126-.126-.185-.194L4.5,24.817H8.83l2.165,3.608,2.165-4.772,1.15-2.535a7.51,7.51,0,0,1-1.15.09A7.143,7.143,0,0,1,10.35,20.641Z"
                        transform="translate(-4.5 -18.9)"
                    />
                    <path
                        id="Path_1432"
                        data-name="Path 1432"
                        d="M23.7,18.907c-.059.063-.122.131-.185.194a7.156,7.156,0,0,1-2.287,1.542l-1.1,2.426-.988,2.183,1.439,3.175,2.165-3.608h4.33Z"
                        transform="translate(-9.747 -18.903)"
                    />
                </g>
            </g>
        </svg>
    );
};
export const ExploreIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={color}
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 16.616 18.127"
        >
            <path
                id="search-alt"
                d="M12.574,4.532a.755.755,0,1,1,0,1.511H6.532a.755.755,0,0,1,0-1.511ZM18.4,17.906a.755.755,0,0,1-1.068,0l-1.818-1.818a3.425,3.425,0,1,1,1.068-1.068L18.4,16.838A.755.755,0,0,1,18.4,17.906Zm-4.688-2.8a1.888,1.888,0,1,0-1.888-1.888A1.888,1.888,0,0,0,13.707,15.106Zm-3.4,1.511H5.776a2.266,2.266,0,0,1-2.266-2.266V3.776A2.266,2.266,0,0,1,5.776,1.511H14.84a.755.755,0,0,1,.755.755V8.308a.755.755,0,0,0,1.511,0V2.266A2.266,2.266,0,0,0,14.84,0H5.776A3.781,3.781,0,0,0,2,3.776V14.351a3.781,3.781,0,0,0,3.776,3.776h4.532a.755.755,0,1,0,0-1.511Z"
                transform="translate(-2)"
                fill={color}
            />
        </svg>
    );
};
export const DashboardIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={color}
            className={classes}
            viewBox="0 0 19.064 19.064"
        >
            <g id="apps" transform="translate(0)">
                <path
                    id="Path_2130"
                    data-name="Path 2130"
                    d="M5.56,0H3.177A3.177,3.177,0,0,0,0,3.177V5.56A3.177,3.177,0,0,0,3.177,8.738H5.56A3.177,3.177,0,0,0,8.738,5.56V3.177A3.177,3.177,0,0,0,5.56,0ZM7.149,5.56A1.589,1.589,0,0,1,5.56,7.149H3.177A1.589,1.589,0,0,1,1.589,5.56V3.177A1.589,1.589,0,0,1,3.177,1.589H5.56A1.589,1.589,0,0,1,7.149,3.177Z"
                    fill={color}
                />
                <path
                    id="Path_2131"
                    data-name="Path 2131"
                    d="M18.56,0H16.177A3.177,3.177,0,0,0,13,3.177V5.56a3.177,3.177,0,0,0,3.177,3.177H18.56A3.177,3.177,0,0,0,21.738,5.56V3.177A3.177,3.177,0,0,0,18.56,0Zm1.589,5.56A1.589,1.589,0,0,1,18.56,7.149H16.177A1.589,1.589,0,0,1,14.589,5.56V3.177a1.589,1.589,0,0,1,1.589-1.589H18.56a1.589,1.589,0,0,1,1.589,1.589Z"
                    transform="translate(-2.673)"
                    fill={color}
                />
                <path
                    id="Path_2132"
                    data-name="Path 2132"
                    d="M5.56,13H3.177A3.177,3.177,0,0,0,0,16.177V18.56a3.177,3.177,0,0,0,3.177,3.177H5.56A3.177,3.177,0,0,0,8.738,18.56V16.177A3.177,3.177,0,0,0,5.56,13Zm1.589,5.56A1.589,1.589,0,0,1,5.56,20.149H3.177A1.589,1.589,0,0,1,1.589,18.56V16.177a1.589,1.589,0,0,1,1.589-1.589H5.56a1.589,1.589,0,0,1,1.589,1.589Z"
                    transform="translate(0 -2.673)"
                    fill={color}
                />
                <path
                    id="Path_2133"
                    data-name="Path 2133"
                    d="M18.56,13H16.177A3.177,3.177,0,0,0,13,16.177V18.56a3.177,3.177,0,0,0,3.177,3.177H18.56a3.177,3.177,0,0,0,3.177-3.177V16.177A3.177,3.177,0,0,0,18.56,13Zm1.589,5.56a1.589,1.589,0,0,1-1.589,1.589H16.177a1.589,1.589,0,0,1-1.589-1.589V16.177a1.589,1.589,0,0,1,1.589-1.589H18.56a1.589,1.589,0,0,1,1.589,1.589Z"
                    transform="translate(-2.673 -2.673)"
                    fill={color}
                />
            </g>
        </svg>
    );
};
export const DiscoveryIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={color}
            className={classes}
            viewBox="0 0 24 24"
        >
            <path d="m5 14c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1s-1-.448-1-1v-2c0-.552.448-1 1-1zm3-2v5c0 .552.448 1 1 1s1-.448 1-1v-5c0-.552-.448-1-1-1s-1 .448-1 1zm-3.5-9c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm4 0c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm15.5 2v6c0 .552-.447 1-1 1s-1-.448-1-1v-2h-20v8c0 1.654 1.346 3 3 3h5c.552 0 1 .448 1 1s-.448 1-1 1h-5c-2.757 0-5-2.243-5-5v-12c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5zm-2 2v-2c0-1.654-1.346-3-3-3h-14c-1.654 0-3 1.346-3 3v2zm1.707 15.293c.391.391.391 1.023 0 1.414s-1.023.391-1.414 0l-2.54-2.54c-.791.524-1.736.833-2.753.833-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5c0 1.017-.309 1.962-.833 2.753zm-6.707-2.293c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3z" />
        </svg>
    );
};

export const MessagesIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={color}
            className={classes}
            viewBox="0 0 19.569 19.57"
        >
            <path
                id="comments"
                d="M19.569,13.046v4.077a2.446,2.446,0,0,1-2.446,2.446H13.046A6.523,6.523,0,0,1,7.4,16.307a8.943,8.943,0,0,0,1.828-.2,4.883,4.883,0,0,0,3.814,1.833h4.077a.815.815,0,0,0,.815-.815V13.046A4.882,4.882,0,0,0,16.1,9.232,8.943,8.943,0,0,0,16.308,7.4,6.523,6.523,0,0,1,19.569,13.046ZM14.658,7.869A7.338,7.338,0,0,0,6.808.019,7.679,7.679,0,0,0,0,7.578v4.11c0,2.065,1.229,2.989,2.446,2.989H7.094a7.68,7.68,0,0,0,7.564-6.808ZM11.375,3.3a5.722,5.722,0,0,1,1.657,4.452,6,6,0,0,1-5.938,5.291H2.446c-.757,0-.815-1.04-.815-1.358V7.578A6,6,0,0,1,6.923,1.645q.2-.015.406-.015A5.717,5.717,0,0,1,11.375,3.3Z"
                transform="translate(0 0.001)"
                fill={color}
            />
        </svg>
    );
};
export const OffersIcon = ({ width, height, classes, color = '#9ea5ab' }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={color}
            className={classes}
            viewBox="0 0 22.118 20.301"
        >
            <path
                id="book"
                d="M21.818,6.545v.909a.909.909,0,1,1-1.818,0V6.545a2.731,2.731,0,0,0-2.727-2.727H4.545A2.731,2.731,0,0,0,1.818,6.545v9.091a2.731,2.731,0,0,0,2.727,2.727H7.273a.909.909,0,1,1,0,1.818H4.545A4.551,4.551,0,0,1,0,15.636V6.545A4.551,4.551,0,0,1,4.545,2H17.273A4.551,4.551,0,0,1,21.818,6.545ZM13.636,8.364h3.636a.909.909,0,1,0,0-1.818H13.636a.909.909,0,0,0,0,1.818Zm7.383,2.617a2.727,2.727,0,0,1,0,3.857l-6.1,6.1A3.614,3.614,0,0,1,12.351,22H10.909A.909.909,0,0,1,10,21.092V19.65a3.61,3.61,0,0,1,1.065-2.571L13.1,15.047l4.066-4.066a2.729,2.729,0,0,1,3.856,0ZM20,12.909a.909.909,0,0,0-1.552-.643l-6.1,6.1a1.834,1.834,0,0,0-.533,1.285v.533h.533a1.806,1.806,0,0,0,1.285-.533l6.1-6.1A.9.9,0,0,0,20,12.909ZM6.364,15.636H8.182a2.731,2.731,0,0,0,2.727-2.727.909.909,0,1,0-1.818,0,.909.909,0,0,1-.909.909H6.364a.91.91,0,0,1-.909-.909V12H7.273a.909.909,0,1,0,0-1.818H5.455V9.273a.91.91,0,0,1,.909-.909H8.182a.91.91,0,0,1,.909.909.909.909,0,0,0,1.818,0A2.731,2.731,0,0,0,8.182,6.545H6.364A2.731,2.731,0,0,0,3.636,9.273v.909a.909.909,0,0,0,0,1.818v.909A2.731,2.731,0,0,0,6.364,15.636Zm6.364-4.545a.909.909,0,1,0,.909-.909A.909.909,0,0,0,12.727,11.091Z"
                transform="translate(0.15 -1.85)"
                fill={color}
                stroke="#fff"
                strokeWidth="0.3"
            />
        </svg>
    );
};

export const InfluencersIcon = ({ width, height, classes, color = '#9ea5ab' }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={width}
            height={height}
            fill={color}
            className={classes}
        >
            <path d="M12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,12,10Zm6,13A6,6,0,0,0,6,23a1,1,0,0,0,2,0,4,4,0,0,1,8,0,1,1,0,0,0,2,0ZM18,8a4,4,0,1,1,4-4A4,4,0,0,1,18,8Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,18,2Zm6,13a6.006,6.006,0,0,0-6-6,1,1,0,0,0,0,2,4,4,0,0,1,4,4,1,1,0,0,0,2,0ZM6,8a4,4,0,1,1,4-4A4,4,0,0,1,6,8ZM6,2A2,2,0,1,0,8,4,2,2,0,0,0,6,2ZM2,15a4,4,0,0,1,4-4A1,1,0,0,0,6,9a6.006,6.006,0,0,0-6,6,1,1,0,0,0,2,0Z" />
        </svg>
    );
};

export const PlannerIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={color}
            className={classes}
            viewBox="0 0 19.232 19.232"
        >
            <path
                id="calendar-clock"
                d="M13.623,8.045a5.594,5.594,0,1,0,5.609,5.578A5.616,5.616,0,0,0,13.623,8.045Zm0,9.585a3.991,3.991,0,1,1,4.007-4.007A4,4,0,0,1,13.623,17.63Zm1.368-3.772a.8.8,0,1,1-1.133,1.133l-.8-.8a.8.8,0,0,1-.235-.567v-1.6a.8.8,0,0,1,1.6,0v1.271Zm4.242-8.248v1.6a.8.8,0,0,1-1.6,0v-1.6a2.407,2.407,0,0,0-2.4-2.4H4.007a2.407,2.407,0,0,0-2.4,2.4v.8H8.815a.8.8,0,1,1,0,1.6H1.6v7.212a2.407,2.407,0,0,0,2.4,2.4H7.212a.8.8,0,0,1,0,1.6H4.007A4.011,4.011,0,0,1,0,15.226V5.609A4.011,4.011,0,0,1,4.007,1.6h.8V.8a.8.8,0,1,1,1.6,0v.8h6.411V.8a.8.8,0,0,1,1.6,0v.8h.8a4.011,4.011,0,0,1,4.007,4.007Z"
                fill={color}
            />
        </svg>
    );
};
export const FavoriteDislikeIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            id="Bold"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            width={width}
            height={height}
            fill={color ?? 'grey'}
            className={classes}
        >
            <path
                fill={color ?? 'grey'}
                d="M486.715,143.036c-11.609-53.966-59.222-92.571-114.422-92.775h-255.34C52.387,50.343,0.07,102.67,0,167.235v106.321  c0.07,64.562,52.391,116.882,116.953,116.953h44.251l32.173,63.006c14.81,28.863,44.709,46.829,77.146,46.356  c46.4,0.061,84.064-37.504,84.125-83.904c0.006-4.769-0.393-9.529-1.195-14.23l-1.914-11.227h43.336  c64.591,0,116.953-52.361,116.953-116.952c0-8.132-0.848-16.243-2.531-24.199L486.715,143.036z M63.792,273.556V167.235  c0-29.36,23.801-53.16,53.16-53.16h31.896v212.641h-31.896C87.593,326.716,63.792,302.916,63.792,273.556z M436.063,307.047  c-10.077,12.471-25.262,19.703-41.295,19.669H275.859l14.608,85.737c1.047,5.875-0.6,11.909-4.487,16.437  c-4.135,4.798-10.236,7.445-16.565,7.187c-8.051,0.085-15.459-4.385-19.138-11.546l-37.637-73.51V114.075h159.651  c25.092,0.074,46.738,17.63,51.991,42.167l22.497,106.321C450.131,278.248,446.189,294.607,436.063,307.047z"
            />
        </svg>
    );
};
export const FavoriteLikeIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            id="Bold"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            width={width}
            height={height}
            fill={color ?? 'grey'}
            className={classes}
        >
            <path
                fill={color ?? 'grey'}
                d="M485.379,170.88c-22.148-27.445-55.547-43.367-90.815-43.293H351.25l1.913-11.222c7.798-45.716-22.94-89.097-68.656-96.895  c-5.03-0.858-10.128-1.256-15.23-1.188c-32.056-0.167-61.464,17.761-76.001,46.332l-32.135,62.973h-44.249  C52.364,127.658,0.07,179.951,0,244.48v106.266c0.07,64.529,52.364,116.822,116.892,116.892H372.1  c55.158-0.2,102.743-38.764,114.363-92.685l22.465-106.266C516.299,234.201,507.639,198.232,485.379,170.88z M63.759,350.745V244.48  c0-29.344,23.788-53.133,53.133-53.133h31.88v212.531h-31.88C87.548,403.878,63.759,380.09,63.759,350.745z M446.549,255.489  l-22.486,106.266c-5.273,24.506-26.897,42.035-51.964,42.124H212.531V167.139l37.533-73.557c3.978-7.446,11.886-11.937,20.318-11.54  c11.174,0.007,20.227,9.072,20.22,20.246c-0.001,1.128-0.096,2.254-0.284,3.366l-14.601,85.693h118.847  c29.344-0.003,53.135,23.783,53.138,53.127C447.703,248.176,447.316,251.867,446.549,255.489L446.549,255.489z"
            />
        </svg>
    );
};

// export const MessagesIcon = ({width, height, classes, color}: iIcon) => {
//     return (
//         <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 21.345 21.345">
//             <path id="comments"
//                   d="M21.345,14.23v4.447a2.668,2.668,0,0,1-2.668,2.668H14.23a7.115,7.115,0,0,1-6.154-3.557,9.754,9.754,0,0,0,1.994-.221,5.326,5.326,0,0,0,4.16,2h4.447a.889.889,0,0,0,.889-.889V14.23a5.325,5.325,0,0,0-2-4.16,9.754,9.754,0,0,0,.224-1.994A7.115,7.115,0,0,1,21.345,14.23ZM15.988,8.583A8,8,0,0,0,7.425.02,8.376,8.376,0,0,0,0,8.266v4.482c0,2.252,1.34,3.26,2.668,3.26H7.737a8.377,8.377,0,0,0,8.251-7.425ZM12.407,3.6a6.242,6.242,0,0,1,1.807,4.856A6.549,6.549,0,0,1,7.737,14.23H2.668c-.825,0-.889-1.134-.889-1.482V8.266A6.547,6.547,0,0,1,7.551,1.795q.221-.016.443-.016A6.236,6.236,0,0,1,12.407,3.6Z"
//                   transform="translate(0 0.001)" fill="#9ea5ab"/>
//         </svg>
//
//     )
// }

export const ReportingIcon = ({ width, height, classes, color }: iIcon) => {
    return (
        <svg
            id="chat-arrow-grow"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={color}
            className={classes}
            viewBox="0 0 18.009 17.991"
        >
            <path
                id="Path_1542"
                data-name="Path 1542"
                d="M18.128,3.976H15.813a.75.75,0,0,0-.531,1.281l.815.815h0l-2.691,2.69a.768.768,0,0,1-1.062,0l-.128-.128a2.3,2.3,0,0,0-3.184,0L5.206,12.461a.753.753,0,1,0,1.066,1.063L10.1,9.7a.768.768,0,0,1,1.062,0l.128.128a2.306,2.306,0,0,0,3.184,0l2.691-2.691h0l.815.815a.75.75,0,0,0,1.276-.532V5.1A1.126,1.126,0,0,0,18.128,3.976Z"
                transform="translate(-1.245 -0.992)"
                fill={color}
            />
            <path
                id="Path_1543"
                data-name="Path 1543"
                d="M17.259,16.491H3.752A2.251,2.251,0,0,1,1.5,14.239V.75A.75.75,0,1,0,0,.75V14.239a3.756,3.756,0,0,0,3.752,3.752H17.259a.75.75,0,1,0,0-1.5Z"
                fill={color}
            />
        </svg>
    );
};
export const ReplaceInfluencerIcon = ({ width, height, classes, color, onClick }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 36.689 24.763"
            fill={color ?? '#05bbc9'}
            className={classes}
            onClick={onClick}
        >
            <g id="Group_4920" data-name="Group 4920" transform="translate(-335.633 -84.627)">
                <g id="Group_4904" data-name="Group 4904" transform="translate(-825.406 -14.688)">
                    <g id="refresh" transform="translate(1161.039 103.501)">
                        <path
                            id="Path_2518"
                            data-name="Path 2518"
                            d="M9.145,1.366a6.851,6.851,0,0,1,4.863,2.049H11.877a.683.683,0,1,0,0,1.366h2.829a1.269,1.269,0,0,0,1.268-1.268V.683a.683.683,0,0,0-1.366,0V2.1A8.182,8.182,0,0,0,.985,7.444a.688.688,0,0,0,.621.748l.062,0a.671.671,0,0,0,.675-.6A6.838,6.838,0,0,1,9.145,1.366Z"
                            transform="translate(-0.982 0)"
                            fill={color ?? '#05bbc9'}
                        />
                        <path
                            id="Path_2519"
                            data-name="Path 2519"
                            d="M56.982,256.006a.671.671,0,0,0-.675.6,6.819,6.819,0,0,1-11.666,4.181h2.132a.683.683,0,0,0,0-1.366H43.943a1.267,1.267,0,0,0-1.268,1.267h0v2.829a.683.683,0,0,0,1.366,0V262.1a8.182,8.182,0,0,0,13.623-5.341.688.688,0,0,0-.621-.748Z"
                            transform="translate(-41.34 -247.811)"
                            fill={color ?? '#05bbc9'}
                        />
                    </g>
                </g>
                <path
                    id="delete-user"
                    d="M9.286,12.382A6.191,6.191,0,1,0,3.1,6.191a6.191,6.191,0,0,0,6.191,6.191Zm0-10.318A4.127,4.127,0,1,1,5.159,6.191,4.127,4.127,0,0,1,9.286,2.064Zm9.286,21.668a1.032,1.032,0,0,1-2.064,0,7.223,7.223,0,1,0-14.445,0,1.032,1.032,0,0,1-2.064,0,9.286,9.286,0,0,1,18.572,0Z"
                    transform="translate(353.75 84.627)"
                    fill={color}
                />
            </g>
        </svg>
    );
};
export const TrashIcon = ({ width, height, classes, color, onClick }: iIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            onClick={onClick}
            fill={color}
            className={classes}
            viewBox="0 0 14.059 16.87"
        >
            <g id="trash" transform="translate(-2)">
                <path
                    id="Path_2191"
                    data-name="Path 2191"
                    d="M15.356,2.812H13.177A3.521,3.521,0,0,0,9.732,0H8.326A3.521,3.521,0,0,0,4.882,2.812H2.7a.7.7,0,0,0,0,1.406h.7v9.138A3.519,3.519,0,0,0,6.921,16.87h4.218a3.519,3.519,0,0,0,3.515-3.515V4.218h.7a.7.7,0,0,0,0-1.406ZM8.326,1.406H9.732a2.113,2.113,0,0,1,1.989,1.406H6.338A2.113,2.113,0,0,1,8.326,1.406Zm4.921,11.95a2.109,2.109,0,0,1-2.109,2.109H6.921a2.109,2.109,0,0,1-2.109-2.109V4.218h8.435Z"
                    fill="#9ea5ab"
                />
                <path
                    id="Path_2192"
                    data-name="Path 2192"
                    d="M9.7,15.623a.7.7,0,0,0,.7-.7V10.7A.7.7,0,1,0,9,10.7v4.218A.7.7,0,0,0,9.7,15.623Z"
                    transform="translate(-2.079 -2.971)"
                    fill="#9ea5ab"
                />
                <path
                    id="Path_2193"
                    data-name="Path 2193"
                    d="M13.7,15.623a.7.7,0,0,0,.7-.7V10.7A.7.7,0,1,0,13,10.7v4.218A.7.7,0,0,0,13.7,15.623Z"
                    transform="translate(-3.268 -2.971)"
                    fill="#9ea5ab"
                />
            </g>
        </svg>
    );
};

export const StarIcon = ({ width = '29', height = '32', classes, color }: iIcon) => {
    return (
        <svg
            fill={color}
            className={classes}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 28.952 32.096"
        >
            <g id="Group_4554" data-name="Group 4554" transform="translate(-847.897 -359.08)">
                <g id="bg" transform="translate(847.896 359.08)">
                    <g id="Group_4527" data-name="Group 4527" transform="translate(0)">
                        <path
                            id="Path_2460"
                            data-name="Path 2460"
                            d="M7.9,3.886c6.374,0,10.75-3.3,13.822-3.3s9.521,1.765,9.521,15.894-8.677,16.2-12.055,16.2C3.368,32.681-3.389,3.886,7.9,3.886Z"
                            transform="translate(-2.29 -0.584)"
                            fill="#efefef"
                        />
                    </g>
                </g>
                <g id="color" transform="translate(849.334 362.371)">
                    <g id="Group_4528" data-name="Group 4528" transform="translate(2.672 2.851)">
                        <path
                            id="Path_2461"
                            data-name="Path 2461"
                            d="M16.868,23.636l-5.611,3.355a.485.485,0,0,1-.721-.524l1.449-6.386a.485.485,0,0,0-.153-.473L6.916,15.3a.486.486,0,0,1,.276-.849l6.507-.592a.484.484,0,0,0,.4-.292l2.572-6.02a.484.484,0,0,1,.89,0l2.572,6.02a.483.483,0,0,0,.4.292l6.507.592a.486.486,0,0,1,.276.849L22.4,19.607a.486.486,0,0,0-.153.473L23.7,26.466a.485.485,0,0,1-.721.524l-5.611-3.355a.489.489,0,0,0-.5,0Z"
                            transform="translate(-6.75 -7.25)"
                            fill="#c3e9ec"
                        />
                    </g>
                    <g id="Group_4531" data-name="Group 4531" transform="translate(2.671 2.851)">
                        <g id="Group_4529" data-name="Group 4529">
                            <path
                                id="Path_2462"
                                data-name="Path 2462"
                                d="M14.06,20.081a.485.485,0,0,0-.153-.473L8.989,15.3a.486.486,0,0,1,.276-.849l6.269-.056a.484.484,0,0,0,.4-.292l2.218-5.17-.592-1.385a.484.484,0,0,0-.89,0L14.1,13.564a.483.483,0,0,1-.4.292l-6.507.592a.486.486,0,0,0-.276.849l4.918,4.311a.486.486,0,0,1,.153.473l-1.449,6.386a.485.485,0,0,0,.721.524l1.428-.854Z"
                                transform="translate(-6.749 -7.249)"
                                fill="#05bbc9"
                            />
                        </g>
                        <g id="Group_4530" data-name="Group 4530" transform="translate(11.403 16.318)">
                            <path
                                id="Path_2463"
                                data-name="Path 2463"
                                d="M20.409,25.027a.483.483,0,0,0-.5,0l-.789.472,4.822,2.884a.485.485,0,0,0,.721-.524l-.075-.33Z"
                                transform="translate(-19.125 -24.959)"
                                fill="#05bbc9"
                            />
                        </g>
                    </g>
                    <g id="Group_4536" data-name="Group 4536" transform="translate(0 0)">
                        <g id="Group_4532" data-name="Group 4532" transform="translate(0.163)">
                            <path
                                id="Path_2464"
                                data-name="Path 2464"
                                d="M0,0H.921V1.843H0Z"
                                transform="translate(0 0.651) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                        <g id="Group_4533" data-name="Group 4533" transform="translate(3.908 3.746)">
                            <path
                                id="Path_2465"
                                data-name="Path 2465"
                                d="M0,0H.921V1.843H0Z"
                                transform="translate(0 0.651) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                        <g id="Group_4534" data-name="Group 4534" transform="translate(0 3.747)">
                            <path
                                id="Path_2466"
                                data-name="Path 2466"
                                d="M0,0H1.843V.921H0Z"
                                transform="translate(0 1.303) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                        <g id="Group_4535" data-name="Group 4535" transform="translate(3.745 0.002)">
                            <path
                                id="Path_2467"
                                data-name="Path 2467"
                                d="M0,0H1.843V.921H0Z"
                                transform="translate(0 1.303) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                    </g>
                    <g id="Group_4537" data-name="Group 4537" transform="translate(23.516 4.464)">
                        <path
                            id="Path_2468"
                            data-name="Path 2468"
                            d="M30.753,11.764a1.382,1.382,0,1,1,1.382-1.382,1.384,1.384,0,0,1-1.382,1.382Zm0-1.843a.461.461,0,1,0,.461.461A.461.461,0,0,0,30.753,9.921Z"
                            transform="translate(-29.371 -9)"
                            fill="#a4afc1"
                        />
                    </g>
                </g>
                <g id="regular" transform="translate(851.316 364.531)">
                    <g id="Group_4538" data-name="Group 4538" transform="translate(0)">
                        <path
                            id="Path_2469"
                            data-name="Path 2469"
                            d="M10.95,27.692A1.177,1.177,0,0,1,9.8,26.255l1.423-6.267L6.4,15.757A1.177,1.177,0,0,1,7.07,13.7l6.384-.58,2.524-5.906a1.175,1.175,0,0,1,2.161,0l2.524,5.907,1.064.1L21.6,14.594l-1.189-.108a1.174,1.174,0,0,1-.977-.712L17.057,8.2l-2.382,5.575a1.171,1.171,0,0,1-.974.71l-6.028.547,4.556,4a1.173,1.173,0,0,1,.372,1.146L11.259,26.09l5.2-3.106a1.175,1.175,0,0,1,1.206,0l5.2,3.107-1.343-5.915a1.175,1.175,0,0,1,.372-1.145l4.556-4-3-.272.126-1.377,3.475.316a1.177,1.177,0,0,1,.667,2.057l-4.825,4.23,1.423,6.267a1.175,1.175,0,0,1-1.749,1.27l-5.5-3.292-5.5,3.291a1.177,1.177,0,0,1-.6.167ZM13.4,13.235v0Zm7.305,0v0Z"
                            transform="translate(-6.001 -6.5)"
                            fill="#2e3033"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const StarProIcon = ({ width = '120', height = '60', classes, color }: iIcon) => {
    return (
        <svg
            fill={color}
            className={classes}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 122.763 62.281"
        >
            <g id="star" transform="translate(-20.567 -0.584)">
                <g id="bg" transform="translate(20.567 0.584)">
                    <g id="Group_4527" data-name="Group 4527" transform="translate(0)">
                        <path
                            id="Path_2460"
                            data-name="Path 2460"
                            d="M13.174,6.991C25.542,6.991,34.035.584,39.995.584S58.471,4.01,58.471,31.426,41.632,62.865,35.077,62.865c-30.7,0-43.807-55.875-21.9-55.875Z"
                            transform="translate(-2.29 -0.584)"
                            fill="#efefef"
                        />
                    </g>
                </g>
                <g id="color" transform="translate(23.357 6.969)">
                    <g id="Group_4528" data-name="Group 4528" transform="translate(5.184 5.533)">
                        <path
                            id="Path_2461"
                            data-name="Path 2461"
                            d="M26.385,39.047,15.5,45.558a.94.94,0,0,1-1.4-1.017l2.813-12.391a.942.942,0,0,0-.3-.917L7.072,22.864a.942.942,0,0,1,.535-1.647l12.627-1.148a.939.939,0,0,0,.78-.567L26,7.821a.938.938,0,0,1,1.727,0L32.722,19.5a.937.937,0,0,0,.78.567l12.627,1.148a.943.943,0,0,1,.535,1.647L37.12,31.23a.943.943,0,0,0-.3.917l2.813,12.391a.94.94,0,0,1-1.4,1.017L27.35,39.046a.948.948,0,0,0-.966,0Z"
                            transform="translate(-6.75 -7.25)"
                            fill="#c3e9ec"
                        />
                    </g>
                    <g id="Group_4531" data-name="Group 4531" transform="translate(5.184 5.533)">
                        <g id="Group_4529" data-name="Group 4529">
                            <path
                                id="Path_2462"
                                data-name="Path 2462"
                                d="M20.935,32.149a.942.942,0,0,0-.3-.917L11.1,22.864a.942.942,0,0,1,.535-1.647l12.164-.109a.939.939,0,0,0,.78-.567l4.3-10.033L27.73,7.821a.938.938,0,0,0-1.727,0L21.012,19.5a.937.937,0,0,1-.78.567L7.605,21.217a.943.943,0,0,0-.535,1.647l9.543,8.366a.943.943,0,0,1,.3.917L14.1,44.538a.94.94,0,0,0,1.4,1.017L18.267,43.9Z"
                                transform="translate(-6.749 -7.249)"
                                fill="#05bbc9"
                            />
                        </g>
                        <g id="Group_4530" data-name="Group 4530" transform="translate(22.128 31.665)">
                            <path
                                id="Path_2463"
                                data-name="Path 2463"
                                d="M21.618,25.092a.938.938,0,0,0-.962,0l-1.531.915,9.357,5.6a.94.94,0,0,0,1.4-1.017l-.145-.64Z"
                                transform="translate(-19.125 -24.959)"
                                fill="#05bbc9"
                            />
                        </g>
                    </g>
                    <g id="Group_4536" data-name="Group 4536" transform="translate(0 0)">
                        <g id="Group_4532" data-name="Group 4532" transform="translate(0.316)">
                            <path
                                id="Path_2464"
                                data-name="Path 2464"
                                d="M0,0H1.788V3.576H0Z"
                                transform="translate(0 1.264) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                        <g id="Group_4533" data-name="Group 4533" transform="translate(7.583 7.27)">
                            <path
                                id="Path_2465"
                                data-name="Path 2465"
                                d="M0,0H1.788V3.576H0Z"
                                transform="translate(0 1.264) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                        <g id="Group_4534" data-name="Group 4534" transform="translate(0 7.272)">
                            <path
                                id="Path_2466"
                                data-name="Path 2466"
                                d="M0,0H3.576V1.788H0Z"
                                transform="translate(0 2.528) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                        <g id="Group_4535" data-name="Group 4535" transform="translate(7.267 0.004)">
                            <path
                                id="Path_2467"
                                data-name="Path 2467"
                                d="M0,0H3.576V1.788H0Z"
                                transform="translate(0 2.528) rotate(-45)"
                                fill="#a4afc1"
                            />
                        </g>
                    </g>
                    <g id="Group_4537" data-name="Group 4537" transform="translate(45.632 8.663)">
                        <path
                            id="Path_2468"
                            data-name="Path 2468"
                            d="M32.053,14.364a2.682,2.682,0,1,1,2.682-2.682,2.685,2.685,0,0,1-2.682,2.682Zm0-3.576a.894.894,0,1,0,.894.894A.9.9,0,0,0,32.053,10.788Z"
                            transform="translate(-29.371 -9)"
                            fill="#a4afc1"
                        />
                    </g>
                </g>
                <g id="regular" transform="translate(27.203 11.162)">
                    <g id="Group_4538" data-name="Group 4538" transform="translate(0)">
                        <path
                            id="Path_2469"
                            data-name="Path 2469"
                            d="M15.6,47.623a2.284,2.284,0,0,1-2.223-2.789l2.761-12.161L6.78,24.463a2.283,2.283,0,0,1,1.295-3.991l12.388-1.125,4.9-11.461a2.279,2.279,0,0,1,4.193,0l4.9,11.463,2.065.188-.241,2.671L33.968,22a2.278,2.278,0,0,1-1.9-1.382L27.456,9.8,22.834,20.62A2.271,2.271,0,0,1,20.944,22l-11.7,1.062,8.84,7.753a2.276,2.276,0,0,1,.722,2.224L16.2,44.514l10.081-6.028a2.28,2.28,0,0,1,2.341,0l10.081,6.029L36.1,33.038a2.281,2.281,0,0,1,.722-2.223l8.84-7.753-5.815-.527.245-2.671,6.743.613a2.283,2.283,0,0,1,1.295,3.991l-9.362,8.209,2.761,12.161A2.28,2.28,0,0,1,38.136,47.3l-10.68-6.389L16.774,47.3a2.285,2.285,0,0,1-1.169.324Zm4.762-28.055a.006.006,0,0,1,0,0Zm14.176-.005,0,0S34.543,19.565,34.542,19.563Z"
                            transform="translate(-6.001 -6.5)"
                            fill="#2e3033"
                        />
                    </g>
                </g>
                <path
                    id="Path_2470"
                    data-name="Path 2470"
                    d="M2.609,26.765a.734.734,0,0,1-.737-.737V6.035a.78.78,0,0,1,.2-.553.7.7,0,0,1,.537-.215h8.23A8.9,8.9,0,0,1,16.644,7a6.187,6.187,0,0,1,2.119,5.083,6.118,6.118,0,0,1-2.1,5.052,9,9,0,0,1-5.82,1.7H6.264v7.186a.739.739,0,0,1-.2.522.7.7,0,0,1-.537.215Zm8.077-11.332a3.99,3.99,0,0,0,2.733-.845,3.171,3.171,0,0,0,.952-2.5,3.35,3.35,0,0,0-.921-2.5,3.793,3.793,0,0,0-2.764-.906H6.2v6.756ZM25.857,26.765a.734.734,0,0,1-.737-.737V6.035a.78.78,0,0,1,.2-.553.7.7,0,0,1,.537-.215h7.954a9.014,9.014,0,0,1,5.881,1.751,6.069,6.069,0,0,1,2.134,4.975,6.288,6.288,0,0,1-1.09,3.762,6.066,6.066,0,0,1-3.025,2.2L42.2,25.782a.764.764,0,0,1,.092.338.6.6,0,0,1-.2.461.641.641,0,0,1-.445.184H38.848a1.156,1.156,0,0,1-.752-.215,2.03,2.03,0,0,1-.476-.614l-3.962-7.278H29.389v7.371a.739.739,0,0,1-.2.522.7.7,0,0,1-.537.215Zm7.862-11.578a4.08,4.08,0,0,0,2.779-.829,3.03,3.03,0,0,0,.937-2.4A3.128,3.128,0,0,0,36.5,9.536a3.981,3.981,0,0,0-2.779-.86h-4.33v6.511ZM57,27.072a9.336,9.336,0,0,1-6.511-2.119q-2.334-2.119-2.457-6.3Q48,17.766,48,16.047q0-1.751.031-2.641A8.4,8.4,0,0,1,50.549,7.14,9.215,9.215,0,0,1,57,4.96a9.272,9.272,0,0,1,6.465,2.18A8.376,8.376,0,0,1,66,13.405q.061,1.781.061,2.641,0,.829-.061,2.61-.154,4.177-2.488,6.3A9.336,9.336,0,0,1,57,27.072Zm0-3.532A4.41,4.41,0,0,0,60.284,22.3,5.5,5.5,0,0,0,61.6,18.5q.061-1.843.061-2.488,0-.706-.061-2.488a5.5,5.5,0,0,0-1.321-3.793,4.922,4.922,0,0,0-6.541,0,5.5,5.5,0,0,0-1.321,3.793q-.031.891-.031,2.488,0,1.566.031,2.488A5.545,5.545,0,0,0,53.727,22.3,4.359,4.359,0,0,0,57,23.54Z"
                    transform="translate(77.273 18.014)"
                    fill="#2e3033"
                />
            </g>
        </svg>
    );
};
